import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { Dispatch, SetStateAction } from 'react';
import { useFormContext } from 'react-hook-form';

import { Button, Typography } from '@/shared/components/atoms';
import { TypographyProps } from '@/shared/components/atoms/Typography/Typography.types';

import Edit from '~/images/shared/edit.svg';

const GeneralTabHeader: React.FC<{
  edit: boolean;
  setEdit: Dispatch<SetStateAction<boolean>>;
  header: string | React.ReactNode;
  title: string;
  saveButtonContent?: string | React.ReactNode;
  actions?: React.ReactNode;
  headerypography?: Omit<TypographyProps, 'children'>;
  editVariant?: 'filled' | 'outlined';
  canEdit?: boolean;
}> = ({
  edit,
  setEdit,
  header,
  title,
  saveButtonContent,
  actions,
  headerypography,
  editVariant = 'filled',
  canEdit = true,
}) => {
  const { t } = useTranslation();

  const { reset } = useFormContext();

  const buttonStyles =
    'flex h-56 min-w-[125px] px-16 items-center justify-center gap-8 !rounded-xl';

  return (
    <div className='flex flex-col items-center justify-between gap-2 tablet:flex-row tablet:gap-0'>
      <div>
        {typeof header === 'string' ? (
          <Typography {...headerypography}>{header}</Typography>
        ) : (
          header
        )}
        <Typography variant='subtitle2' className='text-surface-10'>
          {title}
        </Typography>
      </div>
      {edit ? (
        <div className='flex items-center gap-16'>
          <Button
            className={classNames(
              buttonStyles,
              'border-xs border-outline-default'
            )}
            size='none'
            variant='text'
            onClick={() => {
              setEdit(false);
              reset();
            }}
          >
            {t('cancel')}
          </Button>
          <Button type='submit' size='none' className={buttonStyles}>
            <>{saveButtonContent || t('save')}</>
          </Button>
        </div>
      ) : canEdit ? (
        <div className='flex items-center gap-16'>
          <Button
            className={classNames(
              buttonStyles,
              editVariant === 'outlined' &&
                'border-xs border-outline-default text-primary-default'
            )}
            size='none'
            variant={editVariant === 'filled' ? 'filled' : 'text'}
            onClick={() => setEdit(true)}
          >
            <>
              <span
                className={classNames(
                  editVariant === 'outlined'
                    ? 'text-primary-default'
                    : 'text-white'
                )}
              >
                <Edit width='24' height='24' />
              </span>
              {t('edit')}
            </>
          </Button>
          {actions}
        </div>
      ) : null}
    </div>
  );
};

GeneralTabHeader.defaultProps = {
  headerypography: {
    variant: 'subtitle',
    weight: 'semiBold',
  },
};

export { GeneralTabHeader };
